import { DateTime } from "luxon";

// Exam-prep dates are stored as UTC but represent America/New_York wall-clock.
const NY = "America/New_York";

// Today's date in NY as "YYYY-MM-DD" (for datetime-local defaults).
export const nyToday = () => DateTime.now().setZone(NY).toFormat("yyyy-MM-dd");

// Format a stored UTC ISO timestamp back to an NY date, e.g. "Jul 6, 2026".
export const fmtNyDate = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("LLL d, yyyy") : "—";

// Format a stored UTC ISO timestamp as an NY date + time, e.g. "Jul 6, 2026 2:30 PM".
export const fmtNyDateTime = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("LLL d, yyyy h:mm a") : "—";

// Date + weekday in NY, e.g. "Mon, Jul 6, 2026" — for the weekly homework rounds table.
export const fmtNyDateDay = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("EEE, LLL d, yyyy") : "—";

// Weekday + date + time in NY, e.g. "Mon, Jul 6, 2026 9:10 AM" — rounds release at exact
// times now (Phase 1 punctual release), so the rounds table shows the time.
export const fmtNyDateTimeDay = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("EEE, LLL d, yyyy h:mm a") : "—";

// Stored UTC timestamp -> "yyyy-MM-dd" in NY, for prefilling an <input type="date">.
export const nyDateInput = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("yyyy-MM-dd") : "";

// Stored UTC timestamp -> "yyyy-MM-dd'T'HH:mm" in NY, for an <input type="datetime-local">.
export const nyDateTimeInput = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("yyyy-MM-dd'T'HH:mm") : "";

// Time-of-day in NY, e.g. "6:00 PM" — for compact calendar labels.
export const fmtNyTime = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("h:mm a") : "";

// Short NY date without the year, e.g. "Jul 1" — for compact chips (enrollment-ended markers).
// Local Date getters would render a midnight-UTC instant as the PREVIOUS day for anyone west
// of UTC; every prep date renders through the NY lens, so this one must too.
export const fmtNyShort = (iso) =>
    iso ? DateTime.fromISO(iso, { zone: "utc" }).setZone(NY).toFormat("LLL d") : "";
